import { render, staticRenderFns } from "./AlvoradaSolicitacaoCirurgiaOPME.vue?vue&type=template&id=76b2da8d&scoped=true"
import script from "./AlvoradaSolicitacaoCirurgiaOPME.vue?vue&type=script&lang=ts"
export * from "./AlvoradaSolicitacaoCirurgiaOPME.vue?vue&type=script&lang=ts"
import style0 from "./AlvoradaSolicitacaoCirurgiaOPME.vue?vue&type=style&index=0&id=76b2da8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b2da8d",
  null
  
)

export default component.exports